import { clearDashboardCachesForProject } from '../dashboard/dashboardProjectCache';
import { clearProjectData } from '../stores/db';
import { useLocationsTreeStore } from '../stores/locationsTreeStore';

const FORCE_REFETCH_KEY_PREFIX = 'gantt:forceRefetch:';

export function getGanttForceRefetchKey(projectId: string): string {
  return `${FORCE_REFETCH_KEY_PREFIX}${projectId}`;
}

/** Mark the next Gantt visit to skip IDB hydrate and load from API. */
export function markGanttForceRefetch(projectId: string): void {
  if (!projectId?.trim() || typeof sessionStorage === 'undefined') {
    return;
  }
  try {
    sessionStorage.setItem(getGanttForceRefetchKey(projectId), '1');
  } catch {
    // ignore quota errors
  }
}

export function consumeGanttForceRefetch(projectId: string): boolean {
  if (!projectId?.trim() || typeof sessionStorage === 'undefined') {
    return false;
  }
  try {
    const key = getGanttForceRefetchKey(projectId);
    const shouldRefetch = sessionStorage.getItem(key) === '1';
    if (shouldRefetch) {
      sessionStorage.removeItem(key);
    }
    return shouldRefetch;
  } catch {
    return false;
  }
}

/** Clear local caches used by Gantt, dashboard, and location hierarchy for a project. */
export async function invalidateGanttProjectCaches(projectId: string): Promise<void> {
  if (!projectId?.trim()) {
    return;
  }
  markGanttForceRefetch(projectId);
  clearDashboardCachesForProject(projectId);
  await clearProjectData(projectId);
  await useLocationsTreeStore.getState().clearTree(projectId);
}
